import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import Layout from "../../components/web/Layout";
import Container from "../../components/ui/container/Container";
import OrderSummary from "../../components/web/order/OrderSummary";
import BreadCrump from "../../components/web/breadcrump/BreadCrump";
import InputField from "../../components/ui/form/InputField";
import TextAreaField from "../../components/ui/form/TextAreaField";
import Alert from "../../components/ui/utils/Alert";
import usePost from "../../hooks/api/usePost";
import apiRequest from "../../utils/apiRequest";
import SelectField from "../../components/ui/form/SelectField";
import UserPartnerAuth from "../../middleware/UserPartnerAuth";
import { ORDER_DEATILS_PRODUCT_ROUTE } from "../../routes/web/rootRoutes";

const Checkout = () => {
  const cart = useSelector((state) => state.user.cart);
  const loading = useSelector((state) => state.user.loading);
  const userProfile = useSelector((state) => state.globalState.userProfile);
  const { post, error, serverErrors } = usePost(apiRequest.completeOrder);

  const formik = useFormik({
    initialValues: {
      paymentMethod: "razorpay",
    },
   
    onSubmit: async (values) => {
      const payload = {
        products: cart.products.map((item) => ({
          product: item.product?._id,
          quantity: item.quantity,
        })),
        subtotal: cart?.products?.reduce((acc, curr) => {
          const quantity = curr.quantity || 0;
          const price = curr.product?.finalPrice || 0;
          return acc + quantity * price;
        }, 0),
        shippingCharges: cart.shippingCharges || 0,
        couponCode: values.couponCode || undefined,
        referBy: cart.referBy || undefined,
      };

      const res = await post({ data: { body: payload } });
      console.log(res?.data?.order?._id);
      if (res?.response) {
          window.location.href = ORDER_DEATILS_PRODUCT_ROUTE(res?.data?.order?._id);
      }
    },
  });

  return (
    <UserPartnerAuth>
      <Layout>
        <BreadCrump />
        <Container>
          <h2 className="my-4 text-2xl font-semibold text-center">Pay Now</h2>

          <form onSubmit={formik.handleSubmit}>
            <div className="flex justify-center items-start">
              <OrderSummary
                formData={formik.values}
                handleChange={formik.handleChange}
                isLoading={loading}
                products={cart?.products}
                handlePlaceOrder={formik.handleSubmit}
              />
            </div>
          </form>
        </Container>
      </Layout>
    </UserPartnerAuth>
  );
};

export default Checkout;
